<template>
  <section class="channel-list" v-if="channelListExits">

    <div class="channel-list-search">
      <input type="text" v-model="searchText" :placeholder="searchPlaceholder">
      <i>
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
          <path fill="#ffffff" d="M7.733 14.47c-3.833 0-6.94-3.064-6.94-6.843C.794 3.847 3.9.782 7.734.782s6.94 3.065 6.94 6.845-3.107 6.844-6.94 6.844zm5.615-1.61a7.537 7.537 0 0 0 2.118-5.233C15.466 3.414 12.004 0 7.733 0 3.463 0 0 3.414 0 7.627c0 4.211 3.462 7.625 7.733 7.625a7.76 7.76 0 0 0 5.042-1.852L17.44 18l.56-.553-4.652-4.587z"/>
        </svg>
      </i>
    </div>

    <div class="channel-scroll">
      <ul class="channel-list-ul optiscroll">
        <div class="optiscroll-content">
          <div class="optiscroll-wrap">
            <channel v-for="channel in filteredChannels" :key="channel.id" :item="channel"/>
          </div>
        </div>
      </ul>
    </div>
  </section>

</template>

<script>
import Channel from './Channel'
import ChannelListMixin from 'mixins/ChannelListMixin'
import { mapMutations, mapActions } from 'vuex'

export default {
  name: 'ChannelList',
  components: {
    Channel
  },
  mixins: [
    ChannelListMixin
  ],
  data: function () {
    return {
      searchText: ''
    }
  },
  computed: {
    filteredChannels: function () {
      return this.favoriteChannelsTv.filter((channel) => {
        return channel.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1 ||
          channel.shortName.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
      })
    },
    searchPlaceholder: function () {
      return this.$t('web_guide_search_channels')
    }
  },
  methods: {
    ...mapMutations([
      'UPDATE_SELECTED_CHANNEL'
    ]),
    ...mapActions([
      'selectChannel'
    ])
  },
  mounted: function () {
    if (this.channelListExits) {
      this.$nextTick(function () {
        this.initOptiscroll()
        // console.log('ChannelList initOptiscroll() on mounted...')
        this.selectChannel(this.favoriteChannelsTv[0])
      })
    }
  },
  watch: {
    channelListExits: function (newValue) {
      if (newValue) {
        this.$nextTick(function () {
          this.initOptiscroll()
          // console.log('ChannelList initOptiscroll() on watch...')

          // Init select channel
          // this.UPDATE_SELECTED_CHANNEL(this.favoriteChannelsTv[0])
          this.selectChannel(this.favoriteChannelsTv[0])
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
    @import 'uc/_variables';

    .channel-list {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 27%;
        padding: 15px 0;
        box-shadow: inset -30px 0 20px -20px rgba(0,0,0,.1);
          .optiscroll-content {
            transform: scale3d(1, 1, 1);
            backface-visiblity: hidden;
            perspective: 1000px;
          }
    }
    .ie .channel-list .optiscroll-content {
      backface-visibility: visible;
    }
    .channel-list-search {
        width: 80%;
        margin-bottom: 20px;
        margin-left: auto;
        margin-right: auto;
        position: relative;
            &:after {
              content: '';
              position: absolute;
              top: 0;
              right: 0;
              width: 50px;
              height: 100%;
              background: url(~assets/images/icons/search-2.png) center center no-repeat;
              background-size: 18px;
            }

            input {
                width: 100%;
                color: #323e43;
                background: #fff;
                border: none;
                font-size: 14px;
                font-family: 'azo-sans-web', sans-serif;
                padding: 10px 50px 10px 10px;
                color: #323e43;
                -webkit-box-shadow: 0px 0 30px 0px rgba(0,0,0,0.1);
                -moz-box-shadow: 0px 0 30px 0px rgba(0,0,0,0.1);
                box-shadow: 0px 0 30px 0px rgba(0,0,0,0.1);
                border: 1px solid #e4e4e4;

                &::-webkit-input-placeholder {
                    opacity: 1;
                    font-style: italic;
                    font-family: 'azo-sans-web', sans-serif;
                    color: rgba(50, 62, 67, 0.502);
                }
                &::-moz-placeholder {
                    opacity: 1;
                    font-style: italic;
                    font-family: 'azo-sans-web', sans-serif;
                    color: rgba(50, 62, 67, 0.502);
                }
                &:-ms-input-placeholder {
                    opacity: 1;
                    font-style: italic;
                    font-family: 'azo-sans-web', sans-serif;
                    color: rgba(50, 62, 67, 0.502);
                }
                &:focus {
                    &::-webkit-input-placeholder {
                        color: transparent;
                    }
                    &::-moz-input-placeholder {
                        color: transparent;
                    }
                    &:-ms-input-placeholder {
                        color: transparent;
                    }
                }
            }
        i {
            position: absolute;
            top: 0;
            right: 0;
            padding-right: 13px;
            line-height: 40px;
            height: 40px;

            svg {
                display: inline-block;
                vertical-align: middle;
                width: 18px;
                height: 18px;
                fill: #ffffff;
            }
        }
    }
    .channel-list-ul {
        position: absolute;
        top: 56px;
        left: 0px;
        right: 0;
        bottom: 16px;
    }
    .optiscroll-wrap {
        padding: 15px 10% 10px;
    }

    @media only screen and (min-width: $breakpoint3) {
        .channel-list-search {
            width: 84%;
                &:after {
                    background-size: 22px;
                }
        }
        .channel-list-search input {
            font-size: 16px;
            padding: 14px 50px 14px 15px;
        }
        .channel-list-ul {
            top: 72px;
        }
        .optiscroll-wrap {
            padding: 15px 8% 10px;
        }
    }
</style>

<style lang="scss">

    // Edge scrollbar fix for channel list
    body.edge .channel-list-ul .optiscroll-h {
      display: none;
    }

</style>



// WEBPACK FOOTER //
// src/containers/sections/Guide/ChannelList.vue